import { render } from "./AssistantsView.vue?vue&type=template&id=7f6d252a&scoped=true&ts=true"
import script from "./AssistantsView.vue?vue&type=script&lang=ts"
export * from "./AssistantsView.vue?vue&type=script&lang=ts"

import "./AssistantsView.vue?vue&type=style&index=0&id=7f6d252a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6d252a"]])

export default __exports__